var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ReportTable',{attrs:{"data":'const' in _vm.data ? _vm.data['const'] : _vm.data,"headers":_vm.headers,"loading":_vm.loading,"sort-by":['value','name'],"is-searchable":false,"is-downloable":true,"is-movable":false,"is-groupable":true,"table-name":_vm.tableName}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b725bb8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/pages/indicators/ReportIndicatorConsult.vue
// module id = null
// module chunks = 